// extracted by mini-css-extract-plugin
module.exports = {"terminal":"terminal_terminal__JyquK","blink":"terminal_blink__2ZqJP"};